import { useNavigate, useParams } from 'react-router-dom';
import ChatStreamView from './ChatStreamView';
import { telegramService } from '../../services/telegram';
import { useTelegramOverlayBack } from '../../hooks/useTelegramOverlayBack';
import { TG_OVERLAY_Z } from '../../services/telegramBackStack';

/** Маршрут `/:translation/chat` — чат в виде модалки с вкладками; закрытие — на премиум-главную. */
export default function ChatStreamRoute() {
  const { translation } = useParams();
  const navigate = useNavigate();
  const closeChat = () => navigate(`/${translation}/home`, { replace: true });

  useTelegramOverlayBack('chatRoute', true, closeChat, TG_OVERLAY_Z.chatRoute);

  return (
    <ChatStreamView
      suppressAuthPrompt={telegramService.isTelegramWebApp}
      onClose={closeChat}
    />
  );
}
